import React, { FunctionComponent } from 'react';
import styles from './styles.module.scss';
import CheckboxTree from 'react-checkbox-tree';
import { ICheckboxFilterItem } from '../../common/models/filter/ICheckboxFilterItem';
import { IBindingCallback1 } from '../../common/models/callback';
import { replaceChildren, mapTree, replaceParentInArray } from './utils';
import { CandidateFilterType } from '../../common/enums/CandidateFilterType';
import { PositionFilterType } from '../../common/enums/PositionFilterType';
import Icon from '../Icon';

interface ICheckboxFilterProps {
  items: ICheckboxFilterItem[];
  onChange: IBindingCallback1<string[]>;
  selected: string[];
}

const CheckboxFilter: FunctionComponent<ICheckboxFilterProps> = (({ items, onChange, selected }) => {
  const selectedChildren = replaceParentInArray(selected);
  const tree = mapTree(items);

  const onSelect = (ids: string[]) => {
    onChange(replaceChildren(ids));
  };

  const expandedNodes = [
    CandidateFilterType.AllActive,
    CandidateFilterType.AllInactive,
    PositionFilterType.AllActivePositions
  ];

  return (
    <div className={styles.treeWrapper}>
      <CheckboxTree
        nodes={tree}
        checked={selectedChildren}
        expanded={expandedNodes}
        onCheck={onSelect}
        icons={{
          check: <Icon icon="checkboxChecked" className="checkbox" />,
          uncheck: <Icon icon="checkboxUnchecked" className="checkbox uncheck" />,
          halfCheck: <Icon icon="checkboxIndeterminate" className="checkbox indeterminate" />,
          expandClose: '',
          expandOpen: '',
          parentClose: '',
          leaf: '',
          parentOpen: ''
        }}
      />
    </div>
  );
});

export default CheckboxFilter;
